export const GET_SERVICES_REQUEST = 'GET_SERVICES_REQUEST';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_ERROR = 'GET_SERVICES_ERROR';

export const GET_CLIENT_SERVICES_REQUEST = 'GET_CLIENT_SERVICES_REQUEST';
export const GET_CLIENT_SERVICES_SUCCESS = 'GET_CLIENT_SERVICES_SUCCESS';
export const GET_CLIENT_SERVICES_ERROR = 'GET_CLIENT_SERVICES_ERROR';

export const UPDATE_CLIENT_SERVICES_REQUEST = 'UPDATE_CLIENT_SERVICES_REQUEST';
export const UPDATE_CLIENT_SERVICES_SUCCESS = 'UPDATE_CLIENT_SERVICES_SUCCESS';
export const UPDATE_CLIENT_SERVICES_ERROR = 'UPDATE_CLIENT_SERVICES_ERROR';

export const UPDATE_USER_SERVICE_REQUEST = 'UPDATE_USER_SERVICE_REQUEST';
export const UPDATE_USER_SERVICE_SUCCESS = 'UPDATE_USER_SERVICE_SUCCESS';
export const UPDATE_USER_SERVICE_ERROR = 'UPDATE_USER_SERVICE_ERROR';
